"use client";

import { motion, useScroll, useTransform } from "framer-motion";
import React, { useRef } from "react";

export default function MultiLayerParallax() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });

  // Animation controls
  const topY = useTransform(scrollYProgress, [0, 1], ["0%", "-50%"]);
  const midY = useTransform(scrollYProgress, [0, 0.5], ["100%", "30%"]); // 50% overlap
  const bottomY = useTransform(scrollYProgress, [0.3, 1], ["100%", "0%"]); // Starts appearing later
  const textY = useTransform(scrollYProgress, [0.2, 1], ["0%", "-50%"]);
  
  // Gradient blend effect
  const gradientOverlay = "linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.8) 100%)";

  return (
    <section className="relative h-[150vh] bg-black">
      <div
        ref={ref}
        className="sticky top-0 h-screen w-screen overflow-hidden"
      >
        {/* BOTTOM layer - slides up from bottom */}
        <motion.div
          className="absolute bottom-0 z-40 w-sreen h-full flex items-end justify-center"
          style={{
            y: bottomY,
            
          }}
        >
          <div 
            className="w-screen h-full  bg-contain bg-no-repeat bg-center"
            style={{ backgroundImage: `url(/BOTTOMCOAL.png)` }}
          />
        </motion.div>

        {/* MID layer - overlaps top by 50% */}
        <motion.div
          className="absolute bottom-0 z-20 w-full h-full flex items-end justify-center"
          style={{
            y: midY,
          }}
        >
          <div 
            className="w-screen h-[150%]  bg-contain bg-no-repeat bg-center"
            style={{ 
              backgroundImage: `url(/MIDCOAL.png)`,
              marginTop: "-30%", // 50% overlap
            }}
          />
        </motion.div>

        {/* TOP layer - with gradient blend */}
        <motion.div
          className="absolute inset-0 z-10 flex items-end justify-center"
          style={{
            y: topY,
          }}
        >
          <div 
            className="w-screen h-full  bg-contain bg-no-repeat bg-bottom"
            style={{ 
              backgroundImage: `${gradientOverlay}, url(/TOPCOAL.png)`,
              backgroundBlendMode: "multiply",
              
            }}
          />
        </motion.div>

        {/* Text overlay */}
        <motion.div 
          className="absolute inset-0 z-30 flex flex-col items-center justify-end"
          style={{
            y: textY,
          }}
        >
          <h1 className="font-bold text-white text-7xl md:text-9xl mb-4">
            WHY
          </h1>
          <h1 className="font-bold text-white text-7xl md:text-9xl">
            COALER
          </h1>
        </motion.div>
      </div>
    </section>
  );
}